import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import DashCard from "../../components/shared/DashCard";
import PrivateApi from '../../services/PrivateApiService';
import SplashPage from '../../pages/SplashPage';
import NotificationModal from "../../components/shared/notification/NotificationModal";
import { useQuery } from "react-query";
import { BsBuildingAdd, BsFillBuildingsFill, BsFillFileEarmarkTextFill } from "react-icons/bs";
import { AiOutlineCloudDownload } from "react-icons/ai";
import { FaBell } from "react-icons/fa";
import { HiSwitchHorizontal } from "react-icons/hi";
import { BiSupport } from "react-icons/bi";
import AnimatedSprite from "../../components/shared/AnimatedSprite";


/**
 * HV DashboardPage
 * 
 * dashboard with quick navigation and counts
 * 
 * @returns gui
 */
const DashboardPage = () => {

    const API = new PrivateApi(); // API calls
    const [animation, setAnimation] = useState(false);

    // fetch data
    const { data, error, isLoading } = useQuery("hwDashboard", API.hw_Dashboard, {staleTime: Infinity});
    const { data: notifications } = useQuery("NOTIFICATIONS", API.get_Notifications_unreaded, {staleTime: Infinity});

    // if loading or error
    if (isLoading) return <SplashPage />;
    if (error) return <SplashPage  />;


    if (Math.random() <0.03) {
        setAnimation(true);
    }


    // GUI
    return (
        <Container className="text-start">
            <Row className="align-items-center">
                <Col xs="6">
                    <h1>Dashboard</h1>
                    <p className="text-secondary">Schnellzugriff auf die wichtigsten Funktionen</p>
                </Col>

                <Col xs="6" className="text-end">
                    <p className="text-muted">{new Date().toLocaleDateString('DE-de')}</p>
                </Col>
            </Row>

            {animation === true?
                <AnimatedSprite show={animation} setShow={setAnimation} />
                :null
            }
            <Row className="mt-5 mb-5 justify-content-center">
                <Col xs="12" md="4" xl="4">
                    <DashCard 
                        schema="muted" 
                        path="/hw/dashboard/gebaeude/"
                        icon={<BsFillBuildingsFill size={80} className="text-muted" />}
                        counter={data.building_count}
                        text="Verwaltete Gebäude"    
                    />
                </Col>
                <Col xs="12" md="4" xl="4">
                    <DashCard
                        schema="primary"
                        path="/hw/dashboard/energieliefervertraege/"
                        icon={<BsFillFileEarmarkTextFill size={80} className="text-primary"/>}
                        counter={data.elv_count} 
                        text="Aktive Energielieferverträge" 
                    />
                </Col>
                <Col xs="12" md="4" xl="4">
                    <DashCard 
                        schema="violet"
                        path="/hw/dashboard/download/"
                        icon={<AiOutlineCloudDownload size={80} className="text-violet"/>}
                        badge={data.invoice_count > 0? `Neue`:undefined} 
                        text="Downloadbereich" 
                    />
                </Col>
            </Row>
            <Row className="mt-3 justify-contetn-center">
                <Col xs="12" md="4" xl="4">
                    <DashCard 
                        schema="warning"
                        path="/hw/dashboard/benachrichtigung/"
                        icon={<FaBell size={80} className="text-warning" />}
                        counter={data.notification_count === 0? "0": data.notification_count}
                        text="Ungelesene Benachrichtigungen" 
                    />
                </Col>
                <Col xs="12" md="4" xl="4">
                    <DashCard
                        schema="cyan"
                        path="/hw/dashboard/support/"
                        icon={<BiSupport size={80} className="text-cyan"/>}
                        counter={data.ticket_count === 0? "0": data.ticket_count} 
                        text="Offene Tickets" 
                    />
                </Col>
                <Col xs="12" md="4" xl="4">
                    <DashCard
                        path="/hw/dashboard/gebaeude/neu/"
                        schema="info"
                        icon={<BsBuildingAdd size={80} className="text-info" />}
                        text="Neue WEG/MEG"
                    />
                </Col>
            </Row>
            <Row className="mt-5 justify-contetn-center">
                <p className="text-muted mb-5">bald verfügbar</p>
                <Col xs="12" md="4" xl="4">
                    <DashCard 
                        schema="violet"
                        icon={<HiSwitchHorizontal size={80} className="text-violet"/>}
                        text="Hausverwaltungswechsel" 
                        disabled 
                    />
                </Col>
            </Row>

            {notifications && notifications.length > 0 ?
                    <NotificationModal notifications={notifications} />
            : null}
        </Container>
    )
}
export default DashboardPage;